import { IGatsbyImageDataObject } from '@et/types/Gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import React from 'react'
interface Props {
  image?: IGatsbyImageDataObject
}
function PatternBonus1(props: Props) {
  const { image } = props
  return (
    <div className='py-12 overflow-hidden et-grid-basic md:gap-y-0 lg:py-20'>

      {/* image */}
      {image && <div className='relative col-span-2 col-start-2 row-start-2 py-4 md:py-0 md:col-start-3 md:col-span-10 lg:col-start-7 lg:col-span-7 lg:row-start-1 lg:row-span-2'>
        <div className='lg:absolute lg:top-1/2 lg:-translate-y-1/2 lg:left-[100px] lg:w-[800px] lg:rotate-12'>
          <GatsbyImage image={image.gatsbyImageData} alt='Procreate Pattern: Bonus 1' />
        </div>
      </div>}

      {/* content */}
      <div className='col-span-2 col-start-2 z-2 md:col-start-4 md:col-span-8 lg:col-start-2 lg:col-span-6 lg:row-start-1 lg:mb-8 xl:pr-11'>
        <span className='text-lg font-semibold text-rusted-400'>Bonus Module 1</span>

        <h2 className='mb-4 text-3xl font-sentinel__SemiBoldItal md:text-5xl'>Dandelion Half Brick + Creating Different Colorways</h2>

      </div>

      <div className='col-span-2 col-start-2 z-2 md:col-start-4 md:col-span-8 lg:col-start-2 lg:col-span-6 lg:row-start-2 xl:pr-11'>

        <p className='mb-4 text-lg lg:text-xl'>We're adding on a 6th project! <span className='italic'>Mostly because I couldn't resist since it was so easy and fun.</span></p>

        <p className='mb-4 text-lg lg:text-xl'>Get ready to draw some simplified dandelion seed heads within a half brick composition template, then bring it into the Pattern Playground to finalize.</p>

        <p className='text-lg lg:text-xl'>
          Next, we'll create 3 different colorways of the same pattern using only 2 gestures, allowing us to recolor artwork on the fly with just a couple of taps. Enjoy limitless variations of your patterns following this easy workflow, extending their lives and giving them new personality through color.
        </p>

      </div>


    </div>
  )
}

export default PatternBonus1